import { createApiClient } from '@ikhua/shared';

const apiClient = createApiClient({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:1000',
});

export default apiClient;
